import CREApi from './_creApi';
import httpClient from '@/apis/base/httpclient';

class CRERepSettlementAPI extends CREApi {
  constructor() {
    super();
  }
  controllerName = 'CRERepSettlements';

  /**
   * Dữ liệu báo cáo
   * NTLOC 08.06.2022
   */
  getDataReport(param) {
    let request = {
      url: this.getAPIUrl() + '/SettlementReport',
      data: param,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Dữ liệu báo cáo
   * TPNAM 30.09.2022
   */
  deleteDataReport(param) {
    let request = {
      url: this.getAPIUrl() + '/SettlementClear',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  
  /**
   * Dữ liệu báo cáo từng tab
   * dqdat1 26.02.2024
   */
  getDataReportTab(param) {
    let request = {
      url: this.getAPIUrl() + '/SettlementTab',
      data: param,
    };

    return httpClient.postAsync(request);
  }
}

export default new CRERepSettlementAPI();
